






import Vue from 'vue'
export default Vue.extend({
  name: 'MoreLink',
  props: {
    link: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: false,
      default: 'もっと見る'
    }
  }
})
